/*
 * @Author: Src
 * @Date: 2026-06-05 17:49:54
 * @LastEditTime: 2026-07-15 16:12:19
 * @LastEditors: Src
 * @FilePath: /work-station/src/services/vehicle.service.ts
 * @Description: 车务服务类
 */
// 车务

import { inject, injectable } from 'inversify';
import HttpClient from './http.service';
import { BASE_CAR_URL } from '@/common/constant';

import StorageService from './storage.service';

@injectable()
export default class vehicleService {
  @inject(HttpClient)
  protected http!: HttpClient;

  @inject(StorageService)
  protected storage!: StorageService;

  /**
   * 新增商品 post
   * @param params
   * @returns
   */
  async addCommodity(params: any) {
    try {
      const res = await this.http.post(`${BASE_CAR_URL}/platform/commodity/add`, params) as any;
      return res;
    } catch (error) {
      return null;
    }
  }

  /**
   * 编辑商品
   * @param params
   * @returns
   */
  async editCommodity(params: any) {
    try {
      const res = await this.http.post(`${BASE_CAR_URL}/platform/commodity/edit`, params) as any;
      return res;
    } catch (error) {
      return null;
    }
  }


  /**
   * 商品列表
   * @param params
   * @returns
   */
  async getCommodityList(params: any) {
    try {
      const res = await this.http.get(`${BASE_CAR_URL}/platform/commodity/list`, { params }) as any;
      return res;
    } catch (error) {
      return null;
    }
  }


  /**
   * 商品详情
   * @param params
   * @returns
   */
  async getCommodityDetail(params: any) {
    try {
      const res = await this.http.get(`${BASE_CAR_URL}/platform/commodity/detail`, { params }) as any;
      return res;
    } catch (error) {
      return null;
    }
  }

  /**
   * 删除商品
   * @param params
   * @returns
   */
  async deleteCommodity(params: any) {
    try {
      const res = await this.http.post(`${BASE_CAR_URL}/platform/commodity/delete`, params) as any;
      return res;
    } catch (error) {
      return null;
    }
  }


  /**
   * 上架商品
   * @param params params
    * @returns
   */
  async pushCommodity(params: any) {
    try {
      const res = await this.http.post(`${BASE_CAR_URL}/platform/commodity/push`, params) as any;
      return res;
    } catch (error) {
      return null;
    }
  }


  /**
   * 商品分类及标签
   * @param params
   * @returns
   */
  async getCommodityCategory(params: any) {
    try {
      // const categories: { data: any[] } | null =
      //   this.storage.get('vehicle_category_list');
      // if (categories && categories.data) {
      //   return categories.data;
      // }
      const res = await this.http.get(`${BASE_CAR_URL}/app/commodity/category`, { params }) as any;
      this.storage.set('vehicle_category_list', {
        data: res,
      });
      return res;
    } catch (error) {
      return null;
    }
  }
}
